"use strict";
/**
 * @name math
 * @author Evan Moon
 * @desc Math polyfill for hyperbolic methods
 */
Math.sinh = function (x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
Math.cosh = function (x) {
    return (Math.pow(Math.E, x)) + (Math.pow(Math.E, -x)) / 2;
};
Math.sign = function (x) {
    return (x >= 0.0) ? 1 : -1;
};
